

<template>
  <div class="login">
    <div class="title">手机号验证码登录</div>
    <div class="tip">如手机号未注册，验证后将自动注册</div>
    <div>
      <van-field
        v-model.trim="infoData.phone"
        placeholder="请输入手机号"
        maxlength="11"
        label="+86"
      />
      <div class="row">
        <van-field
          type="number"
          v-model.trim="infoData.code"
          placeholder="请输入验证码"
          maxlength="6"
          label="验证码"
        />
        <van-button @click="getCode" :disabled="codeBtnDisabled">{{
          countDown == 0 ? "获取验证码" : `${countDown}s`
        }}</van-button>
      </div>
      <van-checkbox v-model="infoData.radio" class="radio"
        >我已阅读并同意易点<a @click="showPdf(1)">《用户协议》</a>及<a
          @click="showPdf(2)"
          >《隐私政策》</a
        ></van-checkbox
      >
      <div class="btn" @click="login">登录</div>
    </div>

    <!-- <s-header name="登录" :back="'/index'"></s-header> -->
    <!-- <img src="@/assets/loading.gif" class="logo" alt=""  /> -->
    <!-- <div class="tip">登录中，请稍后</div> -->
  </div>
</template>

<script>
import { reactive, toRefs, onMounted } from 'vue'
import { bindPhone, sendCode } from '@/api/huijuinterface'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
// import qs from 'qs'
// import vueImgVerify from '@/components/VueImageVerify'
// import { login, register } from '@/api/login'
// import md5 from 'js-md5'
// import { reLaunch, navigateTo } from '@/utils/common'


import { Toast } from 'vant'
export default {
  setup() {
    const store = useStore()
    const router = useRouter()
    const state = reactive({
      title: '手机号绑定',
      infoData: {
        phone: '',
        code: '',
        radio: false
      },
      codeBtnDisabled: false,
      countDown: 0,
      btnDisabled: false,
      timer: null
    })
    document.title = state.title

    onMounted(() => {
      // 登录失效返回首页
      if (!sessionStorage.getItem('huijuToken')) {
        let query = sessionStorage.getItem('scenPayExchangeQuery')
        if (query) query = JSON.parse(query)
        router.replace({ path: '/scenPayExchange', query })
      }
    })

    // 登录
    const login = async () => {
      // console.log(state.infoData);
      if (!state.infoData['phone']) return Toast(`手机号不能为空！`)
      if (!state.infoData['code']) return Toast(`验证码不能为空！`)
      if (!state.infoData['radio']) return Toast(`请阅读并同意用户协议`)
      if (state.btnDisabled) return Toast('请勿频繁操作！')
      let obj = {
        phone: state.infoData.phone,
        code: state.infoData.code,
      }
      state.btnDisabled = true;
      bindPhone(obj).then(async () => {
        Toast.success('手机号绑定成功');
        let query = sessionStorage.getItem('scenPayExchangeQuery')
        if (query) query = JSON.parse(query)
        router.replace({ path: '/scenPayExchange', query })
      }).catch(() => {
        setTimeout(() => {
          state.btnDisabled = false;
        }, 1000);
      })
    }

    const getCode = () => {
      if (/^\d{11}$/.test(state.infoData.phone) == false) return Toast(`请输入正确的手机号`)
      let obj = {
        phone: state.infoData.phone,
      }
      state.codeBtnDisabled = true;
      state.countDown = 60;
      sendCode(obj).then(() => {
        state.timer = setInterval(() => {
          if (state.countDown <= 0) {
            state.codeBtnDisabled = false;
            clearTimer()
          } else {
            state.countDown--
          }
        }, 1000)
      }).catch(res => {
        Toast(res.message)
        state.codeBtnDisabled = false;
        state.countDown = 0;
      })
    }
    const clearTimer = () => {
      clearInterval(state.timer)
      state.timer = null;
    }
    const showPdf = (type) => {
      let url = `/scenarioPdf?type=${type}`
      // pdfjs-dist pdf预览插件 在旧版本浏览器上会报错，提示”globalThis is not defined “
      // 这里做兼容处理
      if (typeof globalThis === 'undefined') {
        window.open(url)
      } else {
        router.push(url)
      }

    }



    return {
      ...toRefs(state),
      login,
      getCode,
      clearTimer,
      showPdf
    }
  },
  components: {
    // sHeader,
  }
}
</script>

<style lang="less" scoped>
.login {
  width: 86%;
  margin: 0px 7%;
  box-sizing: border-box;
  .title {
    margin: 45px 0 7px 0;
    font-size: 22px;
    font-weight: 500;
    color: #1a1a1a;
  }
  .tip {
    margin-bottom: 30px;
    font-size: 12px;
    color: #666666;
  }
  .row {
    display: flex;
    align-items: flex-start;
    margin: 0 auto;
    border-bottom: 0.02667rem solid #ebedf0;
    .van-button {
      margin-top: 7px;
      padding: 0 10px;
      width: 55%;
      font-size: 14px;
      border: none;
      color: #ff2b21;
      background: none;
    }

    .van-cell::after {
      right: 0;
      border-bottom: none;
    }
  }
  .van-cell {
    padding: 15px 0px;
    background: none;
  }
  .van-cell::after {
    left: 0;
    width: 100%;
  }
  .radio {
    margin-top: 20px;
    font-size: 11px;
    font-weight: 400;
    color: #666666;
    a {
      color: #0077e5;
    }
  }
  .btn {
    margin-top: 60px;
    width: 320px;
    height: 40px;
    line-height: 40px;
    background: #ff2b21;
    border-radius: 20px;
    color: #fff;
    font-size: 16px;
    text-align: center;
  }
}
</style>
